export default "__VITE_ASSET__UMM$T32r__"